export const PasswordReqEx = /^(?=.*[0-9])(?=.*[A-zàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßŁłØøÅåÆæœ])[A-zàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßŁłØøÅåÆæœ0-9$&+,:;=?@#|'<>.^*()%!-]{6,}$/;
